















import { Component, Vue } from 'vue-property-decorator';
import { Card, Checkbox } from 'element-ui';

const OPEN_LINK_NEW_TAB = 'link_new_tab';

@Component({
  components: {
    'el-card': Card,
    'el-checkbox': Checkbox
  }
})

export default class Others extends Vue {
  private openLinkInNewTab = sessionStorage.getItem(OPEN_LINK_NEW_TAB) === 'true';

  saveOpenLinkInNewTab(value: boolean) {
    sessionStorage.setItem(OPEN_LINK_NEW_TAB, value.toString());
  }
}
